
import { mapState } from 'vuex'
import { setMetaRobots } from '@/utils/utils'
export default {
  head() {
    return {
      title:
        this.$t('home.footer.info_protection') + ' - ' + this.$t('home.title'),
      meta: [setMetaRobots(false)]
    }
  },
  mounted() {
    document.title = this.$t('home.title')
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting
    })
  }
}
